export const uploadOssConfig = {
  host: 'https://img.hetao101.com',
  policyText: {
    expiration: '2021-01-01T12:00:00.000Z', // 设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
    conditions: [
      ['content-length-range', 0, 1048576000] // 设置上传文件的大小限制
    ]
  },
  uploadUrl: 'https://img.hetao101.com'
}

export function isTestEnv() {
  const origin = window.location.origin;
  let res = []
  if (origin.indexOf('lianmeng') !== -1) {
    res = origin.match(/testing\d*/g);
  }
  return res;
}

function domainConfig() {
  return !isTestEnv() ? 'https://api.pipacoding.com' : `https://api.${isTestEnv()[0] || 'testing'}.pipacoding.com`
}

function hetaoDomainConfig() {
  return !isTestEnv() ? 'https://api.hetao101.com' : `https://api.${isTestEnv()[0] || 'testing'}.hetao101.com`
}

function consoleDomainConfig() {
  return !isTestEnv() ? 'https://console.pipacoding.com' : `https://console.${isTestEnv()[0] || 'testing'}.pipacoding.com`
}

function corpConfig () {
  if (window.location.origin.indexOf('console.pipacoding.com') !== -1) {
    return 'https://dusertag.corp.hetao101.com'
  }
  return 'https://t1dusertag.corp.hetao101.com'
}
export const commonConfig = {
  apiUrl: domainConfig(),
  consoleUrl: consoleDomainConfig(),
  apiHetaoDomain: hetaoDomainConfig(),
  corpUrl: corpConfig(),
  devApiUrl: 'https://zt.dev.pipacoding.com'
}

// 神策配置

export const saConfig = {
  token: '2ebc266b891588684cf10b1a676b7b69086abc7ed7699cbd3162fdec08a577f1',
  saHost: 'https://sensors.corp.hetao101.com',
  project: 'production'
}
